import { useEffect } from 'react';
import {
	useRecoilValue,
	useRecoilValueLoadable,
	useSetRecoilState
} from 'recoil';

import {
	initAndLinkProgressMessageState,
	initAndLinkProgressState,
	jsonTablesState
} from '../../atoms';
import UI from '../../domains/UI';
import {
	useConfigQuery,
	useGetUnavailableProductsQuery,
	usePricesQuery
} from '../../graphql';
import { storeIdState } from '../../Store/atoms';

import { useAddScreenMessageHandler } from '../useAddScreenMessageHandler';
import { useAppDispatch } from '../../reduxstore/hooks';
import { setUnavailableProductIds } from '../../domains/UI/store/slice';
import { mapTables } from '@biggby-coffee/percomatic-typescript/dist/src/utils';
import { initAndLink } from '@biggby-coffee/percomatic-typescript/dist/src/api';

export const useFetchProductData = (): void => {
	const jsonTables = useRecoilValueLoadable(jsonTablesState);
	const storeId = useRecoilValue(storeIdState);
	const setInitAndLinkProgress = useSetRecoilState(initAndLinkProgressState);
	const setInitAndLinkProgressMessage = useSetRecoilState(
		initAndLinkProgressMessageState
	);
	const addScreenMessageHandler = useAddScreenMessageHandler();
	const dispatch = useAppDispatch();

	// set unavailable ids on startup & data

	const { data: unavailableProducts } = useGetUnavailableProductsQuery({
		fetchPolicy: 'network-only',
		variables: { storeId: storeId }
	});

	const { data, error } = useConfigQuery({
		fetchPolicy: 'network-only',
		variables: { storeId: storeId }
	});

	const { data: priceData, error: priceError } = usePricesQuery({
		fetchPolicy: 'network-only',
		variables: { storeId: storeId }
	});

	UI.actions.useApolloError(error);
	UI.actions.useApolloError(priceError);

	useEffect(() => {
		if (data && priceData && jsonTables.state === 'hasValue') {
			const definedTables = data.tables;
			const tables = jsonTables.valueOrThrow();

			if (unavailableProducts) {
				dispatch(
					setUnavailableProductIds(
						unavailableProducts.unavailableProducts.map(
							product => product.productId
						)
					)
				);
			}

			setInitAndLinkProgress(0);
			setInitAndLinkProgressMessage('Downloading menu data...');
			try {
				const mappedTables = mapTables({
					...tables,
					config: [],
					itemPrices: priceData.itemPrice,
					modifierPrices: priceData.modifierPrice
				});
				initAndLink(
					{
						...mappedTables,
						config: [
							...definedTables.config,
							{
								storeId: 0,
								termId: 0,
								setting: 'IsOnlineOrdering',
								value: '1'
							},
							{
								storeId: 0,
								termId: 0,
								setting: 'SizeBlacklist',
								value: '5,6,7,21'
							}
						]
					},
					storeId,

					({ initAndLinkProgress, initAndLinkProgressMessage }) => {
						setInitAndLinkProgress(initAndLinkProgress);
						setInitAndLinkProgressMessage(
							initAndLinkProgressMessage
						);
					},
					undefined,
					addScreenMessageHandler
				);
			} catch (e) {
				console.error(e);
			}

			// worker
			// 	.mapTables({
			// 		...tables,
			// 		config: [],
			// 		itemPrices: priceData.itemPrice,
			// 		modifierPrices: priceData.modifierPrice
			// 	})
			// 	.then(mappedTables =>
			// 		worker.initAndLink(
			// 			{
			// 				...mappedTables,
			// 				config: [
			// 					...definedTables.config,
			// 					{
			// 						storeId: 0,
			// 						termId: 0,
			// 						setting: 'IsOnlineOrdering',
			// 						value: '1'
			// 					},
			// 					{
			// 						storeId: 0,
			// 						termId: 0,
			// 						setting: 'SizeBlacklist',
			// 						value: '5,6,7,21'
			// 					}
			// 				]
			// 			},
			// 			storeId,
			// 			proxy(
			// 				({
			// 					initAndLinkProgress,
			// 					initAndLinkProgressMessage
			// 				}) => {
			// 					setInitAndLinkProgress(initAndLinkProgress);
			// 					setInitAndLinkProgressMessage(
			// 						initAndLinkProgressMessage
			// 					);
			// 				}
			// 			),
			// 			undefined,
			// 			proxy(addScreenMessageHandler)
			// 		)
			// 	)
			// 	.catch(console.error);
		}
	}, [
		data,
		priceData,
		jsonTables,
		setInitAndLinkProgress,
		setInitAndLinkProgressMessage,
		storeId,
		addScreenMessageHandler,
		dispatch,
		unavailableProducts
	]);
};
